// Mock data for NishanthAradhya Tools website

export const companyInfo = {
  name: "NishanthAradhya",
  tagline: "Powerful Tools for Everyday Tasks",
  description: "We create innovative Android applications designed to simplify your daily tasks. From PDF management to file transfers and creative tools, our apps deliver powerful features with intuitive, user-friendly experiences.",
  email: "aradhyanishanth84@gmail.com",
  phone: "+91 6363191544",
  address: "Mysore, Karnataka, India"
};

export const apps = [
  {
    id: 1,
    name: "PDF Hub",
    description: "Your complete PDF manager - read, edit, merge, split, compress, and annotate PDF documents with ease",
    category: "Productivity",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.pdfhub",
    icon: "📑",
    screenshot: "/screenshots/pdfhub.jpg",
    rating: 4.9,
    downloads: "300K+",
    features: ["PDF Reader & Editor", "Merge & Split PDFs", "Compress PDFs", "Add Annotations"],
    status: "published"
  },
  {
    id: 2,
    name: "SmartZip",
    description: "Powerful file compression and extraction tool supporting ZIP, RAR, 7Z and more formats with batch processing",
    category: "Utilities",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.smartzip",
    icon: "📦",
    screenshot: "/screenshots/smartzip.jpg",
    rating: 4.7,
    downloads: "200K+",
    features: ["Multi-Format Support", "Batch Compression", "Extract Archives", "Password Protection"],
    status: "coming_soon"
  },
  {
    id: 3,
    name: "FocusHub",
    description: "Boost your productivity with a distraction-free focus timer, task management, and habit tracking all in one app",
    category: "Productivity",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.focushub",
    icon: "🎯",
    screenshot: "/screenshots/focushub.jpg",
    rating: 4.9,
    downloads: "100K+",
    features: ["Pomodoro Timer", "Task Management", "Focus Statistics", "Daily Goals"],
    status: "coming_soon"
  },
  {
    id: 4,
    name: "NearTransfer",
    description: "Lightning-fast wireless file sharing between Android devices and PC with WiFi Direct technology - no internet required",
    category: "Productivity",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.neartransfer",
    icon: "📲",
    screenshot: "/screenshots/neartransfer.jpg",
    rating: 4.7,
    downloads: "100K+",
    features: ["WiFi Direct Transfer", "Connect to PC", "No Internet Needed", "Ultra Fast Speed"],
    status: "coming_soon"
  },
  {
    id: 5,
    name: "NovaCraft Studio",
    description: "Create stunning stop motion animations using photos or drawings with professional-grade tools, onion skinning, and timeline editing",
    category: "Creative",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.novacraft",
    icon: "🎬",
    screenshot: "/screenshots/novacraft.png",
    rating: 4.8,
    downloads: "150K+",
    features: ["Photo-Based Animation", "Drawing Mode", "Onion Skinning", "Timeline Editor"],
    status: "coming_soon"
  },
  {
    id: 6,
    name: "PDF Gen",
    description: "Generate professional PDFs from images, documents, and templates with powerful creation and conversion tools",
    category: "Productivity",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.pdfgen",
    icon: "📄",
    screenshot: "/screenshots/pdfgen.jpg",
    rating: 4.8,
    downloads: "500K+",
    features: ["Image to PDF", "Document Converter", "PDF Templates", "Batch Creation"],
    status: "coming_soon"
  },
  {
    id: 7,
    name: "Ats.Ai",
    description: "Land your dream job with AI-powered resume building, real-time ATS scoring, smart cover letters, and expert optimization tips — all in one app",
    category: "Career & Productivity",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.atsai",
    icon: "🤖",
    screenshot: "/screenshots/atsai.jpg",
    rating: 4.9,
    downloads: "50K+",
    features: ["AI Resume Builder", "ATS Score Checker", "Smart Cover Letters", "Job Tailoring"],
    status: "published",
    appId: "atsai"
  },
  {
    id: 8,
    name: "GeoCam Pro",
    description: "Professional camera with real-time GPS tagging, compass overlay, and professional field data collection tools",
    category: "Utility & Tools",
    downloadLink: "https://play.google.com/store/apps/details?id=com.nexaaradhya.geocam",
    icon: "📸",
    screenshot: "/screenshots/geocam.jpg",
    rating: 4.8,
    downloads: "20K+",
    features: ["GPS Location Overlay", "Magnetic Compass", "Tactical Map Styles", "Field Data Export"],
    status: "published",
    appId: "geocam"
  },
  {
    id: 9,
    name: "OurVerse",
    description: "Real-time synchronization space for partners with shared doodles, mini-games, voice calling, and synced music.",
    category: "Social",
    downloadLink: "#",
    icon: "🌌",
    screenshot: "/screenshots/ourverse.jpg",
    rating: 4.9,
    downloads: "Coming Soon",
    features: ["Doodle with Me", "Flash Mini-game", "Voice Calling", "Sync Music"],
    status: "coming_soon",
    appId: "ourverse"
  }
];

export const features = [
  {
    title: "Free & Powerful",
    description: "All our tools are free to use with no hidden costs. Get premium features without the premium price tag.",
    icon: "✨"
  },
  {
    title: "Works Offline",
    description: "Most features work without internet connection. Your data stays on your device, ensuring privacy and accessibility.",
    icon: "📴"
  },
  {
    title: "Lightning Fast",
    description: "Optimized for speed and efficiency. Complete your tasks in seconds, not minutes.",
    icon: "⚡"
  },
  {
    title: "Easy to Use",
    description: "Intuitive interfaces designed for everyone. No technical knowledge required to get started.",
    icon: "🎯"
  }
];

export const testimonials = [
  {
    name: "David Wilson",
    role: "Freelance Designer",
    comment: "PDF Hub has become essential for my work. Managing documents is now a breeze and the quality is excellent!",
    rating: 5
  },
  {
    name: "Lisa Chang",
    role: "Content Creator",
    comment: "Photo Editor Pro is incredible! I've edited amazing photos for my social media without any prior experience.",
    rating: 5
  },
  {
    name: "James Thompson",
    role: "IT Professional",
    comment: "NearTransfer saves me so much time. Sharing large files between devices without cables or internet is a game-changer.",
    rating: 5
  }
];
